import { lazy, Suspense, useState } from 'react';
import { Routes, Route, Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Home } from './routes/Home';
import { Login } from './routes/Login';
import { Features } from './routes/Features';
import { About } from './routes/About';
import { Footer } from './components/Footer';
import { useAuth } from './auth';

// Code-split the reader so pdf.js/epub.js load only when opening a book.
const Reader = lazy(() => import('./routes/Reader').then((m) => ({ default: m.Reader })));

export function App() {
  const { pathname } = useLocation();
  // The reader is a full-screen surface; it renders its own chrome.
  const inReader = pathname.startsWith('/read/');

  return (
    <div className={inReader ? 'app' : 'app has-sidebar'}>
      {!inReader && <Sidebar />}
      <div className="main">
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/read/:bookId"
              element={
                <Suspense fallback={<section className="hero"><p className="muted">Loading reader…</p></section>}>
                  <Reader />
                </Suspense>
              }
            />
            {/* SPA fallback: unknown routes render Home for now. */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        {!inReader && <Footer />}
      </div>
    </div>
  );
}

function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  // On mobile the sidebar becomes a top bar; the hamburger toggles the nav.
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);
  return (
    <aside className={menuOpen ? 'sidebar open' : 'sidebar'}>
      <div className="side-top">
        <Link to="/" className="brandlink" onClick={close}>
          <img src="/logo.png" alt="" className="brandmark" />
          <span className="brand">ScrollWind</span>
        </Link>
        <button
          type="button"
          className="hamburger"
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          ☰
        </button>
      </div>
      <nav className="sidenav">
        {user && <NavLink to="/" className="sidelink" end onClick={close}>Library</NavLink>}
        <NavLink to="/features" className="sidelink" onClick={close}>Features</NavLink>
        <NavLink to="/about" className="sidelink" onClick={close}>About</NavLink>
      </nav>
      <div className="sideauth">
        {user ? (
          <>
            <span className="muted sideuser">{user.displayName || user.email}</span>
            <button
              type="button"
              className="linkbtn"
              onClick={async () => {
                close();
                await logout();
                navigate('/');
              }}
            >
              Sign out
            </button>
          </>
        ) : (
          <Link to="/login" className="btn btn-small" onClick={close}>Sign in</Link>
        )}
      </div>
    </aside>
  );
}
